import { render } from "./PillNav.vue?vue&type=template&id=12ff32da&scoped=true"
import script from "./PillNav.vue?vue&type=script&lang=js"
export * from "./PillNav.vue?vue&type=script&lang=js"

import "./PillNav.vue?vue&type=style&index=0&id=12ff32da&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ff32da"]])

export default __exports__